import { render, staticRenderFns } from "./adicionarSaldoPix.vue?vue&type=template&id=278d7e7f&scoped=true"
import script from "./adicionarSaldoPix.vue?vue&type=script&lang=ts"
export * from "./adicionarSaldoPix.vue?vue&type=script&lang=ts"
import style0 from "./adicionarSaldoPix.vue?vue&type=style&index=0&id=278d7e7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278d7e7f",
  null
  
)

export default component.exports